module.exports = __webpack_public_path__ + "hbomaxar-static/media/LiquidTrip_OpenLoop_00211.88d7e130.png";